export default __webpack_public_path__ + "static/SRUS P389 - Product Specifications & Technical Data-8f1d6a8f8c8ab67a27bdde1c19f1afdc.pdf";